export var AttributeType;
(function (AttributeType) {
    AttributeType["Hero"] = "Hero";
    AttributeType["Promoted"] = "Promoted";
    AttributeType["Standard"] = "Standard";
})(AttributeType || (AttributeType = {}));
export const getAttributeType = (attribute) => {
    if (attribute.isPromoted)
        return AttributeType.Promoted;
    if (isHeroAttribute(attribute))
        return AttributeType.Hero;
    return AttributeType.Standard;
};
export const isHeroAttribute = (attribute) => attribute.displayPriority === 1 && !attribute.isPromoted;
export const getHeroAttributeStyle = (attribute, heroAttributeColours) => {
    const attributeColor = heroAttributeColours[attribute.id];
    return attributeColor ? { backgroundColor: attributeColor } : undefined;
};
//# sourceMappingURL=utils.js.map